import { Action } from 'redux';

import { close } from './close';
import { NOTIFICATIONS_NOTIFY_TYPE } from '../../constants/actionTypes';
import { TThunkAction } from '../../types/redux';
import { ENotificationStyle } from '../../types/notifications';

export type TNotificationsNotifyType = 'notifications/notify';

export interface INotificationsNotifyType extends Action<TNotificationsNotifyType> {
  type: TNotificationsNotifyType;
  text: string;
  style: ENotificationStyle;
}

let lastNotificationId: Symbol;
export function notify(text: string, style?: ENotificationStyle): TThunkAction {
  return (dispatch, getState) => {
    const notificationId = (lastNotificationId = Symbol());

    dispatch<INotificationsNotifyType>({
      text,
      style: style || ENotificationStyle.Default,
      type: NOTIFICATIONS_NOTIFY_TYPE,
    });

    setTimeout(() => {
      const {
        notifications: { text },
      } = getState();

      if (notificationId === lastNotificationId && text) {
        dispatch(close());
      }
    }, 5000);
  };
}
